var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.alreadyReset
      ? _c(
          "div",
          [
            _c("h1", [_vm._v(_vm._s(_vm.$t("passwordForgotten.title")))]),
            _vm._v(" " + _vm._s(_vm.$t("passwordForgotten.content")) + " "),
            _c(
              "v-form",
              {
                ref: "form",
                attrs: { "lazy-validation": "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.passwordReset($event)
                  }
                },
                model: {
                  value: _vm.isValid,
                  callback: function($$v) {
                    _vm.isValid = $$v
                  },
                  expression: "isValid"
                }
              },
              [
                _c("v-text-field", {
                  attrs: {
                    rules: [_vm.rules.required, _vm.rules.email],
                    label: "Email"
                  },
                  model: {
                    value: _vm.email,
                    callback: function($$v) {
                      _vm.email = $$v
                    },
                    expression: "email"
                  }
                })
              ],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: { disabled: !_vm.isValid, color: "success" },
                on: { click: _vm.passwordReset }
              },
              [_vm._v(_vm._s(_vm.$t("global.send")))]
            )
          ],
          1
        )
      : _vm._e(),
    _vm.alreadyReset
      ? _c(
          "div",
          [
            _c("h1", [
              _vm._v(_vm._s(_vm.$t("passwordForgotten.alreadyResetTitle")))
            ]),
            _vm._v(
              " " +
                _vm._s(_vm.$t("passwordForgotten.alreadyResetContent")) +
                " "
            ),
            _c("v-btn", { attrs: { color: "primary", to: "/login" } }, [
              _vm._v(_vm._s(_vm.$t("passwordForgotten.goBackToLogin")))
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }